import { render, staticRenderFns } from "./PlanningCollapsableBookingsList.vue?vue&type=template&id=1c28c38b&"
import script from "./PlanningCollapsableBookingsList.vue?vue&type=script&lang=js&"
export * from "./PlanningCollapsableBookingsList.vue?vue&type=script&lang=js&"
import style0 from "./PlanningCollapsableBookingsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports